import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import ConfirmDialog from '../components/ConfirmDialog';
import i18n from '../i18n';

const ConfirmContext = createContext(null);

export const ConfirmProvider = ({ children }) => {
  const [dialog, setDialog] = useState(null);

  const closeDialog = useCallback((result) => {
    setDialog((current) => {
      current?.resolve(result);
      return null;
    });
  }, []);

  const confirm = useCallback((message, options = {}) => (
    new Promise((resolve) => {
      setDialog({
        message,
        title: options.title || i18n.t('confirmTitle', { ns: 'common' }),
        confirmLabel: options.confirmLabel || i18n.t('confirm', { ns: 'common' }),
        cancelLabel: options.cancelLabel || i18n.t('cancel', { ns: 'common' }),
        danger: Boolean(options.danger),
        resolve
      });
    })
  ), []);

  const value = useMemo(() => ({ confirm }), [confirm]);

  return (
    <ConfirmContext.Provider value={value}>
      {children}
      {dialog && (
        <ConfirmDialog
          isOpen
          title={dialog.title}
          message={dialog.message}
          confirmLabel={dialog.confirmLabel}
          cancelLabel={dialog.cancelLabel}
          danger={dialog.danger}
          onConfirm={() => closeDialog(true)}
          onCancel={() => closeDialog(false)}
        />
      )}
    </ConfirmContext.Provider>
  );
};

export const useConfirm = () => {
  const context = useContext(ConfirmContext);
  if (!context) {
    throw new Error('useConfirm must be used within ConfirmProvider');
  }
  return context.confirm;
};
